import * as React from 'react'

import { ImportsCardsPanel } from './ImportsCardsPanel'
import { RouteComponentProps } from '@/app/navigation/withRouter'
import { ScannedChartsSection } from './components/ScannedChartsSection'

export const ImportsHomeCards = ({
  match,
}: RouteComponentProps<{ companyId: string }>) => {
  const { companyId } = match.params
  const [chartListVersion, setChartListVersion] = React.useState(0)


  return (
    <div className="tw-flex tw-flex-col tw-gap-6">
      <ImportsCardsPanel
        companyId={companyId}
        onChartSuccess={() => setChartListVersion((version) => version + 1)}
      />
      <ScannedChartsSection key={`${companyId}-${chartListVersion}`} companyId={companyId} />
    </div>
  )
}
